import ObjectNotFoundError from 'components/Error/ObjectNotFoundError'
import StoryNotFoundError from 'components/Error/StoryNotFoundError'
import { useRouter } from 'next/router'

const NotFoundPage = () => {
  const router = useRouter()

  return <ObjectNotFoundError objectTitle='Page' action={router.back} />
}

export default NotFoundPage
